import React, { useState } from 'react';
const image1 = 'images/designer.png';
const image2 = 'images/config.png';
const image3 = 'images/analytics.png';
const image4 = 'images/pullrequest.png';
const image5 = 'images/deployment.png';


// Workflow steps data
const workflowSteps = [
  {
    id: 1,
    title: "Design Infrastructure",
    shortDescription: "Drag-and-drop interface to design cloud architecture",
    description: "Use the drag-and-drop interface to visually design your cloud architecture. Connect services, configure components, and visualize your entire infrastructure.",
    color: "bg-blue-500",
    keyPoints: [
      "Visual service catalog",
      "Drag & drop interface",
      "Multi-cloud support",
      "Real-time validation"
    ],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42" />
      </svg>
    )
  },
  {
    id: 2,
    title: "Configure & Review",
    shortDescription: "Set up properties and review Terraform code",
    description: "Set up each component's properties, review the generated Terraform code, and make adjustments as needed to optimize your infrastructure.",
    color: "bg-indigo-500",
    keyPoints: [
      "Smart configuration",
      "Auto Terraform generation",
      "Security rules",
      "Best practices"
    ],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
      </svg>
    )
  },
  {
    id: 3,
    title: "Cost & Security Analysis",
    shortDescription: "Get cost estimates and security analysis",
    description: "Get instant cost estimations and detect security vulnerabilities before deployment to ensure your infrastructure is both cost-effective and secure.",
    color: "bg-purple-500",
    keyPoints: [
      "Instant cost estimations",
      "Security vulnerability detection",
      "Pre-deployment analysis",
      "Cost-effective & secure infrastructure"
    ],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
        {/* Escudo con símbolo de dólar */}
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 2L3 7v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5z" />
                 <line x1="12" y1="3" x2="12" y2="21"></line>
         <path d="M15 7H10.5a2.5 2.5 0 0 0 0 5h4a2.5 2.5 0 0 1 0 5H9" />
      </svg>
    )
  },
  {
    id: 4,
    title: "Version Control & Approval",
    shortDescription: "Save to Git and create pull requests",
    description: "Save changes to Git, create pull requests, and implement approval workflows to ensure proper governance of infrastructure changes.",
    color: "bg-violet-500",
    keyPoints: [
      "Git integration",
      "Pull request management",
      "Approval workflows",
      "Infrastructure governance"
    ],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
      </svg>
    )
  },
  {
    id: 5,
    title: "Deploy & Monitor",
    shortDescription: "Deploy with one click and monitor in real-time",
    description: "Deploy your infrastructure with a single click and monitor the deployment process in real-time, with the ability to roll back if needed.",
    color: "bg-pink-500",
    keyPoints: [
      "One-click deployment",
      "Real-time monitoring",
      "Rollback capabilities",
      "Automated deployment"
    ],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
      </svg>
    )
  }
];

const WorkflowDemoComponent = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [imageSrc, setImageSrc] = useState(image1);



  // Handle step click
  const handleStepClick = (stepId) => {
    setActiveStep(stepId);
    switch (stepId) {
      case 1:
        setImageSrc(image1);
        break;
      case 2:
        setImageSrc(image2);
        break;
      case 3:
        setImageSrc(image3);
        break;
      case 4:
        setImageSrc(image4);
        break;
      case 5:
        setImageSrc(image5);
        break;
      default:
        setImageSrc(image1);
    }
  };

  return (
    <section id="workflow" className="pt-0 pb-0 md:pt-24">
      <div className="container px-4 py-4 mx-auto">
        {/* Section heading */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="section-heading reveal fade-bottom">
            Streamlined workflow from design to deployment
          </h2>
          <p className="section-subheading reveal fade-bottom">
            Cloudima provides a complete GitOps workflow that simplifies the entire infrastructure lifecycle, from visual design to secure deployment.
          </p>
        </div>

        {/* Interactive workflow display */}
        <div className="grid md:grid-cols-2 gap-10 items-center px-0">
          {/* Left side: Steps */}
          <div className="space-y-6 reveal fade-right">
            {workflowSteps.map((step) => (
              <div
                key={step.id}
                className={`relative p-4 md:p-6 rounded-xl transition-all duration-300 cursor-pointer ${activeStep === step.id
                  ? 'bg-black/70 shadow-lg scale-105 border border-cloudima-blue/20'
                  : 'bg-black/40 hover:bg-black/60 hover:shadow'
                  }`}
                onClick={() => handleStepClick(step.id)}
              >
                {/* Connector line between steps */}
                {step.id < workflowSteps.length && (
                  <div className={`absolute left-6 bottom-0 w-0.5 h-6 -mb-6 ${activeStep === step.id || activeStep === step.id + 1
                    ? step.color
                    : 'bg-gray-600'
                    }`}></div>
                )}

                {/* Step content */}
                <div className="flex items-start gap-4">
                  <div className={`flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full text-white shrink-0 transition-colors ${activeStep === step.id ? step.color : 'bg-gray-600'
                    }`}>
                    {step.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold text-base md:text-lg">{step.title}</h3>
                    <p className="text-gray-300 mt-1 text-sm md:text-base">{step.shortDescription}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right side: Visual representation */}
          <div className="reveal fade-left">
            <div className="relative p-1 md:p-2">
              {/* Mostrar la imagen en lugar del contenido de las pestañas */}
              <img src={imageSrc} alt={`Step ${activeStep}`} className="w-full h-auto" />
            </div>
            {/* Content below image */}
            <div className="mt-4 rounded-lg backdrop-blur-sm">
              {/* Title */}
              <h4 className="font-semibold text-lg text-white mb-3">
                {workflowSteps.find(step => step.id === activeStep)?.title}
              </h4>

              {/* Description */}
              <p className="text-gray-300 text-sm md:text-base leading-relaxed">
                {workflowSteps.find(step => step.id === activeStep)?.description}
              </p>

              {/* Key Points */}
              <div className="grid grid-cols-2 gap-3 mb-4">
                {workflowSteps.find(step => step.id === activeStep)?.keyPoints.map((point, index) => (
                  <div key={index} className="bg-black/40 rounded-lg p-3 border border-cloudima-blue/20">
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-cloudima-blue rounded-full"></div>
                      <span className="text-gray-300 text-xs md:text-sm">{point}</span>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkflowDemoComponent;
